export default __webpack_public_path__ + "static/media/Tailwind Regular.3b47e966.woff2";